function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawSocialShare = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1146 790.98",
    style: style
  }, props), React.createElement("g", {
    opacity: 0.6
  }, React.createElement("path", {
    d: "M175.37 357.82l3-136.39a8.07 8.07 0 0 1 7.3-7.85 1029.74 1029.74 0 0 1 194.08 0 8.07 8.07 0 0 1 7.34 8v136.37a8.06 8.06 0 0 1-7.67 8.05c-66.86 3.14-132.38 3.29-196.37 0a8.06 8.06 0 0 1-7.68-8.18z",
    fill: "#36334a"
  }), React.createElement("path", {
    d: "M175.37 357.82l3-136.39a8.07 8.07 0 0 1 7.3-7.85 1029.74 1029.74 0 0 1 194.08 0 8.07 8.07 0 0 1 7.34 8v136.37a8.06 8.06 0 0 1-7.67 8.05c-66.86 3.14-132.38 3.29-196.37 0a8.06 8.06 0 0 1-7.68-8.18z",
    fill: "#36334a"
  }), React.createElement("path", {
    d: "M175.37 357.82l3-136.39a8.07 8.07 0 0 1 7.3-7.85 1029.74 1029.74 0 0 1 194.08 0 8.07 8.07 0 0 1 7.34 8v136.37a8.06 8.06 0 0 1-7.67 8.05c-66.86 3.14-132.38 3.29-196.37 0a8.06 8.06 0 0 1-7.68-8.18z",
    fill: primaryColor,
    opacity: 0.2
  }), React.createElement("rect", {
    x: 197.5,
    y: 238.48,
    width: 74,
    height: 17,
    rx: 2.25,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 198,
    y: 267.98,
    width: 169,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("rect", {
    x: 198,
    y: 288.98,
    width: 169,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("rect", {
    x: 198,
    y: 309.98,
    width: 112,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  })), React.createElement("g", {
    opacity: 0.6
  }, React.createElement("path", {
    d: "M664.37 148.82l3-136.39a8.07 8.07 0 0 1 7.3-7.85 1029.74 1029.74 0 0 1 194.08 0 8.07 8.07 0 0 1 7.34 8v136.37a8.06 8.06 0 0 1-7.67 8c-66.86 3.14-132.38 3.29-196.37 0a8.06 8.06 0 0 1-7.68-8.13z",
    fill: "#36334a"
  }), React.createElement("path", {
    d: "M664.37 148.82l3-136.39a8.07 8.07 0 0 1 7.3-7.85 1029.74 1029.74 0 0 1 194.08 0 8.07 8.07 0 0 1 7.34 8v136.37a8.06 8.06 0 0 1-7.67 8c-66.86 3.14-132.38 3.29-196.37 0a8.06 8.06 0 0 1-7.68-8.13z",
    fill: "#36334a"
  }), React.createElement("path", {
    d: "M664.37 148.82l3-136.39a8.07 8.07 0 0 1 7.3-7.85 1029.74 1029.74 0 0 1 194.08 0 8.07 8.07 0 0 1 7.34 8v136.37a8.06 8.06 0 0 1-7.67 8c-66.86 3.14-132.38 3.29-196.37 0a8.06 8.06 0 0 1-7.68-8.13z",
    fill: primaryColor,
    opacity: 0.2
  }), React.createElement("rect", {
    x: 686.5,
    y: 29.48,
    width: 74,
    height: 17,
    rx: 2.25,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 687,
    y: 58.98,
    width: 169,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("rect", {
    x: 687,
    y: 79.98,
    width: 169,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("rect", {
    x: 687,
    y: 100.98,
    width: 112,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  })), React.createElement("path", {
    d: "M1146 687.49c0 9.49-7.07 18.67-20.31 27.4-9.46 6.24-22.06 12.24-37.49 17.94-44 16.29-110.92 30.17-193.18 40.28q-10.39 1.27-21.1 2.48c-87.45 9.76-190.54 15.4-300.92 15.4-316.46 0-573-46.34-573-103.5s256.54-103.5 573-103.5 573 46.33 573 103.5z",
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 541,
    cy: 716.98,
    rx: 210,
    ry: 42,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M1082 651.49c0 23.2-74 42.49-190 42.49s-210-18.81-210-42 94-42 210-42 190 18.31 190 41.51zM1122.69 713.49c-8.84 6.7-20.42 13.17-34.49 19.33-44 16.29-110.92 30.17-193.18 40.28q-10.39 1.27-21.1 2.48c-20.84-6.54-32.92-14.28-32.92-22.6 0-23.2 94-42 210-42 25.18 0 49.32.89 71.69 2.51z",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 712.58,
    y: 192,
    width: 10.31,
    height: 85.02,
    rx: 2.29,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 369.76,
    y: 125.4,
    width: 5.79,
    height: 27.99,
    rx: 1.5,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 369.55,
    y: 176.64,
    width: 6.52,
    height: 48.72,
    rx: 1.69,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 369.65,
    y: 242.4,
    width: 6.21,
    height: 49.14,
    rx: 1.61,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 373.04,
    y: 32.9,
    width: 345.1,
    height: 701.37,
    rx: 35.69,
    fill: "#3f3d56"
  }), React.createElement("rect", {
    x: 512.3,
    y: 53.84,
    width: 48.19,
    height: 9.79,
    rx: 2.54,
    fill: "#36334a"
  }), React.createElement("circle", {
    cx: 573.33,
    cy: 58.74,
    r: 5.55,
    fill: "#36334a"
  }), React.createElement("path", {
    d: "M696.83 78.58v610a27.41 27.41 0 0 1-27.41 27.4H421.76a27.41 27.41 0 0 1-27.41-27.4v-610a27.41 27.41 0 0 1 27.41-27.41h37.06v4.76a22.58 22.58 0 0 0 22.57 22.56h126a22.57 22.57 0 0 0 22.57-22.57v-4.76h39.51a27.41 27.41 0 0 1 27.36 27.42z",
    fill: "#36334a"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M403 109.47h31v4h-31zM403 116.47h31v4h-31zM403 123.47h31v4h-31z"
  }), React.createElement("path", {
    fill: "#3f3d56",
    d: "M403 109.47h31v4h-31zM403 116.47h31v4h-31zM403 123.47h31v4h-31zM682.66 119.49h-.91l-.35-.29a7.61 7.61 0 0 0 1.78-4.89 7.44 7.44 0 1 0-7.4 7.48 7.73 7.73 0 0 0 4.88-1.78l.34.28v.92l5.74 5.76 1.72-1.73zm-6.88 0a5.18 5.18 0 1 1 5.16-5.18 5.15 5.15 0 0 1-5.16 5.18z"
  }), React.createElement("path", {
    d: "M35.6 676.63c3-5.51-.4-12.26-4.29-17.17s-8.61-10-8.51-16.29c.15-9 9.7-14.32 17.33-19.09a84 84 0 0 0 15.56-12.51 23 23 0 0 0 4.78-6.4c1.58-3.52 1.54-7.52 1.44-11.37q-.51-19.31-1.91-38.49",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), React.createElement("path", {
    d: "M74.51 554.61a14 14 0 0 0-7-11.5l-3.14 6.21.1-7.52a14.22 14.22 0 0 0-4.63-.56 14 14 0 1 0 14.68 13.37zM49.48 649.6a14 14 0 1 1 .68-11.3l-8.77 7.13L51 643.2a14 14 0 0 1-1.52 6.4zM42.55 622.35a14 14 0 0 1-4.45-27.53l-.1 5.78 3.18-6.29a14 14 0 0 1 14.67 13.36 13.84 13.84 0 0 1-.6 4.79 14 14 0 0 1-12.7 9.89zM76.62 599.68a14 14 0 1 1 6.21-26.27l-2.48 6.8 5.1-4.9a14 14 0 0 1 4.53 9.69 13.79 13.79 0 0 1-.35 3.87 14.05 14.05 0 0 1-13.01 10.81z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M72.62 558.35c-3.24.35-6.39 1.36-9.64 1.56s-6.82-.58-8.88-3.1c-1.1-1.36-1.66-3.09-2.59-4.57a10 10 0 0 0-3.51-3.33 14 14 0 1 0 26.24 9.32q-.82.03-1.62.12zM76.62 599.68a14 14 0 0 1-13.35-20 10.37 10.37 0 0 1 2.82 2.81c1 1.51 1.61 3.25 2.78 4.64 2.19 2.57 5.92 3.41 9.31 3.26s6.66-1.12 10-1.43c.47 0 .94-.07 1.42-.08a14.05 14.05 0 0 1-12.98 10.8zM42.55 622.35a14 14 0 0 1-13.46-19.76 11.48 11.48 0 0 1 3 2.85c1.09 1.54 1.77 3.31 3.05 4.73 2.37 2.64 6.35 3.57 9.93 3.48s6.83-.92 10.28-1.19a14 14 0 0 1-12.8 9.89zM49.48 649.6a14.017 14.017 0 0 1-25.59-11.45 13.8 13.8 0 0 1 3.11 2.74c1.34 1.63 2.22 3.48 3.76 5 2.87 2.82 7.5 4 11.63 4.09a62.17 62.17 0 0 0 7.09-.38z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M14.43 670.29s11.08-.34 14.42-2.72 17-5.21 17.86-1.4 16.65 19 4.15 19.06-29.06-2-32.4-4-4.03-10.94-4.03-10.94z",
    fill: "#656380"
  }), React.createElement("path", {
    d: "M51.08 683.9c-12.51.1-29.06-1.94-32.39-4-2.54-1.55-3.55-7.1-3.89-9.65h-.37s.7 8.93 4 11 19.89 4.08 32.4 4c3.61 0 4.85-1.31 4.78-3.21-.47 1.12-1.84 1.84-4.53 1.86z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M261.27 626.27c-4.74-8.78.64-19.54 6.82-27.37s13.73-16 13.57-26c-.23-14.34-15.45-22.81-27.62-30.42a134.77 134.77 0 0 1-24.79-19.93c-3-3.05-5.87-6.31-7.62-10.2-2.52-5.61-2.45-12-2.29-18.13q.79-30.71 3-61.34",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), React.createElement("path", {
    d: "M199.26 431.81a22.32 22.32 0 0 1 11.16-18.32l5 9.91-.15-12a22.37 22.37 0 1 1-16 20.42zM239.14 583.19a22.36 22.36 0 1 0-1.08-18l14 11.37-15.37-3.56a22.24 22.24 0 0 0 2.45 10.19zM250.19 539.76a22.37 22.37 0 0 0 7.09-43.88l.12 9.22-5.06-10h-.06a22.37 22.37 0 1 0-2.09 44.69zM195.89 503.63a22.37 22.37 0 1 0-9.89-41.85l4 10.83-8.13-7.81a22.37 22.37 0 0 0 14.07 38.83z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M202.26 437.77c5.17.56 10.19 2.17 15.37 2.49s10.87-.92 14.14-4.95c1.77-2.17 2.65-4.91 4.14-7.28a16.06 16.06 0 0 1 5.63-5.3 22.37 22.37 0 1 1-41.81 14.85c.85.03 1.69.09 2.53.19zM195.89 503.63a22.38 22.38 0 0 0 21.28-31.9 16.34 16.34 0 0 0-4.5 4.5c-1.59 2.4-2.56 5.18-4.43 7.39-3.48 4.1-9.44 5.44-14.84 5.19s-10.6-1.78-16-2.27c-.75-.07-1.5-.12-2.26-.14a22.37 22.37 0 0 0 20.75 17.23zM250.19 539.76a22.37 22.37 0 0 0 21.46-31.49 17.83 17.83 0 0 0-4.73 4.55c-1.74 2.45-2.82 5.27-4.86 7.54-3.77 4.2-10.11 5.68-15.83 5.55-5.54-.13-10.87-1.48-16.38-1.91a22.36 22.36 0 0 0 20.34 15.76zM239.14 583.19a22.37 22.37 0 0 0 40.78-18.25 22.27 22.27 0 0 0-4.91 4.38c-2.13 2.59-3.53 5.53-6 7.94-4.57 4.49-11.95 6.34-18.52 6.52a99.32 99.32 0 0 1-11.35-.59z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M295 616.16s-17.65-.54-23-4.33-27.16-8.31-28.48-2.24S217 639.81 237 639.97s46.31-3.1 51.62-6.34 6.38-17.47 6.38-17.47z",
    fill: "#656380"
  }), React.createElement("path", {
    d: "M236.6 637.86c19.93.16 46.31-3.11 51.62-6.34 4-2.46 5.65-11.3 6.19-15.38h.59s-1.12 14.24-6.43 17.47-31.69 6.5-51.62 6.34c-5.75 0-7.74-2.09-7.63-5.12.8 1.85 2.99 2.99 7.28 3.03z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M696.83 410.79V688.6a27.41 27.41 0 0 1-27.41 27.4H421.76a27.41 27.41 0 0 1-27.41-27.4V411.33a1191.52 1191.52 0 0 0 302.48-.54z",
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 515,
    cy: 353.98,
    r: 4,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 533,
    cy: 353.98,
    r: 4,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 551,
    cy: 353.98,
    r: 4,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("circle", {
    cx: 569,
    cy: 353.98,
    r: 4,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M440.37 303.82l3-136.39a8.07 8.07 0 0 1 7.3-7.85 1029.74 1029.74 0 0 1 194.08 0 8.07 8.07 0 0 1 7.34 8v136.37a8.06 8.06 0 0 1-7.67 8.05c-66.86 3.14-132.38 3.29-196.37 0a8.06 8.06 0 0 1-7.68-8.18zM696.83 161.32v154.64q-10.77-.93-21.46-2a8 8 0 0 1-7.25-8.58l9.51-136.09a8.06 8.06 0 0 1 7.67-7.49q5.76-.26 11.53-.48zM394.44 161.32v154.64q10.77-.93 21.46-2a8 8 0 0 0 7.25-8.58l-9.51-136.09a8.06 8.06 0 0 0-7.67-7.49q-5.76-.26-11.53-.48z",
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("rect", {
    x: 462.5,
    y: 184.48,
    width: 74,
    height: 17,
    rx: 2.25,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 463,
    y: 213.98,
    width: 169,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("rect", {
    x: 463,
    y: 234.98,
    width: 169,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("rect", {
    x: 463,
    y: 255.98,
    width: 112,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M472.14 529.49a18.85 18.85 0 0 1-5.41 1.49 9.54 9.54 0 0 0 4.15-5.22 18.86 18.86 0 0 1-6 2.29 9.45 9.45 0 0 0-16.08 8.6 26.75 26.75 0 0 1-19.45-9.87 9.55 9.55 0 0 0-1.27 4.75 9.44 9.44 0 0 0 4.21 7.86 9.26 9.26 0 0 1-4.29-1.18v.12a9.44 9.44 0 0 0 7.57 9.26 9.7 9.7 0 0 1-2.48.33 8.74 8.74 0 0 1-1.78-.18 9.45 9.45 0 0 0 8.82 6.56 18.87 18.87 0 0 1-11.72 4 18.62 18.62 0 0 1-2.25-.14 26.36 26.36 0 0 0 14.44 4.33c17.37 0 26.87-14.4 26.87-26.88v-1.22a19 19 0 0 0 4.67-4.9zM566.67 525.1h-33.29a2.07 2.07 0 0 0-2.07 2.06v33.33a2.07 2.07 0 0 0 2.07 2.07H550v-14.85h-4.47v-5.46H550v-4c0-4.83 3.35-7.46 7.67-7.46 2.07 0 4.29.16 4.8.22v5h-3.44c-2.34 0-2.79 1.11-2.79 2.75v3.48h5.59l-.73 5.46h-4.86v14.79h10.41a2.07 2.07 0 0 0 2.06-2.07v-33.26a2.06 2.06 0 0 0-2.04-2.06zM654.2 528.12a7.82 7.82 0 0 1 7.79 7.79v15.58a7.82 7.82 0 0 1-7.79 7.79h-15.6a7.82 7.82 0 0 1-7.79-7.79v-15.6a7.82 7.82 0 0 1 7.79-7.79h15.6m0-3.12h-15.6a10.94 10.94 0 0 0-10.91 10.91v15.6a10.94 10.94 0 0 0 10.91 10.91h15.6a10.94 10.94 0 0 0 10.91-10.91v-15.6A10.94 10.94 0 0 0 654.2 525z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M656.53 535.91a2.34 2.34 0 1 1 2.34-2.33 2.33 2.33 0 0 1-2.34 2.33zm-10.13 1.58a6.24 6.24 0 1 1-6.24 6.24 6.25 6.25 0 0 1 6.24-6.24m0-3.11a9.36 9.36 0 1 0 9.36 9.35 9.35 9.35 0 0 0-9.36-9.37z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 759.46,
    cy: 413.52,
    r: 18.57,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 804.77,
    cy: 454.75,
    rx: 52.1,
    ry: 67.5,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M804.77 501.86c-26.1 0-47.72-24.86-51.51-57.3a87.45 87.45 0 0 0-.59 10.19c0 37.28 23.32 67.5 52.1 67.5s52.09-30.22 52.09-67.5a87.45 87.45 0 0 0-.59-10.19c-3.79 32.44-25.41 57.3-51.5 57.3z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M910.78 652.43c-1.12 4.6-5.94 8.28-11.29 10.85-11.23 5.41-25.08 7-38.52 7.57a66.63 66.63 0 0 1-10.29-.19c-7-.84-13.56-3.84-17.64-8.11a2.42 2.42 0 0 1 .07-4.1c7.15-7.86 19.09-12.67 31.12-16.14 9.12-2.64 25-9.45 35-8.53 9.6.89 12.96 12.84 11.55 18.65z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M910.78 652.43c-1.12 4.6-5.94 8.28-11.29 10.85-11.23 5.41-25.08 7-38.52 7.57a66.63 66.63 0 0 1-10.29-.19c-7-.84-13.56-3.84-17.64-8.11a2.42 2.42 0 0 1 .07-4.1c7.15-7.86 19.09-12.67 31.12-16.14 9.12-2.64 25-9.45 35-8.53 9.6.89 12.96 12.84 11.55 18.65z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M768 618.07a28.43 28.43 0 0 0-1.72 21.7 37.85 37.85 0 0 0 12.71 18c14.53 11.65 34.53 13.25 53.16 13.09a410.57 410.57 0 0 0 48.77-3.37c5.4-.7 10.85-1.52 15.84-3.68 6.08-2.63 11.42-7.45 13.59-13.71s.63-13.93-4.51-18.11c-4.52-3.67-10.75-4.17-16.56-4.52L856 625.49c3.29-3.32 7.66-5.2 11.66-7.62 5.3-3.21 8.83-8.59 12.69-13.44 5.76-7.25 12.57-13.58 19.34-19.89 1.09 6.2 5 11.3 9.63 15.58s9.95 7.73 14.75 11.81c11.63 9.87 20 23.27 32.24 32.39a63.08 63.08 0 0 0 23.1-11.53l-4.75-8.61a5.73 5.73 0 0 0-1.79-2.24c-1.35-.83-3.08-.4-4.65-.64-4.17-.62-6-5.44-7.63-9.34-4.5-10.68-13.12-19-20.47-27.93a140.94 140.94 0 0 1-14.39-21.2c-2.48-4.46-4.74-9.11-8.09-13s-8.06-6.87-13.16-6.88c-4.51 0-8.67 2.28-12.55 4.58a332.58 332.58 0 0 0-34 23.18c-5.67 4.41-11.32 9.06-18 11.77-2.8 1.13-5.76 1.91-8.45 3.3-4.71 2.42-8.29 6.52-12.14 10.17-13.69 13.03-32.49 21.44-51.34 22.12z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M837.47 525.6a34.55 34.55 0 0 1-2.5 11.57c-1.64 3.61-4.53 6.81-8.3 8a17.72 17.72 0 0 1-8.1.26 15.62 15.62 0 0 1-6.6-2.24c-3.11-2.15-4.67-6-5.23-9.71s-.32-7.56-.68-11.32a61.48 61.48 0 0 0-1.73-9c-.24-1-.49-2-.74-2.94s-.47-2-.69-2.93-.39-1.85-.54-2.78c-.14-.78-.25-1.57-.34-2.36-.26-2.33-.3-4.74-1.16-6.93a21.88 21.88 0 0 0-2.43-4.11c-.41-.59-.81-1.17-1.18-1.79a8.44 8.44 0 0 1-1.4-5.39 5 5 0 0 1 .21-.87c0-.11.08-.21.13-.32a2.62 2.62 0 0 0 1.77-1.65 4.88 4.88 0 0 0-.22-2.56 16.13 16.13 0 0 0-1.38-3.29c-.38-.69-1.67-1.93-1.68-2.72 0-1.59 3.08-2.87 4.34-3.49a24.19 24.19 0 0 1 12.37-2.54c2.74.18 5.72 1 7.23 3.32 1.36 2.07 1.18 4.76 1.76 7.16a2.05 2.05 0 0 0 .43 1 1.93 1.93 0 0 0 1.06.49 6.65 6.65 0 0 0 2 .08 4.85 4.85 0 0 0 .53-.08 7.11 7.11 0 0 0 2.93-1.26c.56-.15 1.12-.27 1.7-.37h.06c2.27 7.16 2.57 14.84 4.43 22.13.91 3.63 2.23 7.21 2.42 10.95v.5c0 1.2-.07 2.41 0 3.6a12.24 12.24 0 0 0 .18 1.6 24.19 24.19 0 0 0 .76 2.51c.09.26.17.53.24.79s.1.39.13.58a21.86 21.86 0 0 1 .22 6.11z",
    fill: "#fbbebe"
  }), React.createElement("circle", {
    cx: 805.67,
    cy: 452.03,
    r: 26.73,
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M975.37 597.66a43.79 43.79 0 0 0-7.54-20.3q1 6.18 2.08 12.36a4.63 4.63 0 0 1-4.85-1.49 15.05 15.05 0 0 1-2.54-4.72 96.87 96.87 0 0 0-11.82-21.21c-17-1.42-33.83-8.47-48.8-16.7s-29-18.07-43.74-26.63a62.47 62.47 0 0 0-8-4.08c-4.62-1.85-9.81-2.81-14.19-5l-.88-.46a17.57 17.57 0 0 1-2.8-1.88 15.49 15.49 0 0 1-1.34-1.23c-2.32-2.41-3.75-5.53-5.12-8.57-2.36-5.2-3.19-11.48-5.54-16.68a16.16 16.16 0 0 1 3.6-2.54l.57-.29a16.36 16.36 0 0 1 2.89-1c.56-.15 1.12-.27 1.7-.37h.06a16.7 16.7 0 0 1 7.91.62c3.72 1.26 6.86 3.78 10 6.15 5 3.76 10.11 7.29 14.61 11.59 2.58 2.48 4.94 5.19 7.72 7.44a59.27 59.27 0 0 0 7.28 4.83l45.08 26.85c5.09 3 10.18 6.06 15.16 9.27 7.55 4.87 14.84 10.15 22.12 15.43l12.86 9.33a14 14 0 0 1 3.65 3.37 12.11 12.11 0 0 1 1.62 4.94 45.26 45.26 0 0 1-1.75 20.97z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M844.09 545.7c-1.8 8.09-10 13-14.24 20.08-5.31 8.82-3.15 19.07-1.15 29.16l-10.94 9.42c-2 1.73-4 3.46-6.18 5a82.54 82.54 0 0 1-9.88 5.67l-9.68 5a46 46 0 0 1-9.47 4c-6.36 1.63-13.11.49-19.39-1.4a8.21 8.21 0 0 1-2.12-.86 3.52 3.52 0 0 1-1-.91 5.65 5.65 0 0 1-.64-3.66c.64-10.58 3.23-20.94 5.8-31.22a92.52 92.52 0 0 1 13.34-32.73c3.46-5.76 6.88-11.63 11.46-16.59 1.95-2.14 4.13-4.18 5.29-6.83 1.61-3.67 1-7.87 1.31-11.87a24.85 24.85 0 0 1 2.35-8.65 24.25 24.25 0 0 1 2.51-4.15l1.32 3.07.86 2 1.11 2.58c1 2.45 2.11 4.9 3.16 7.36 1.3 3 2.63 6.09 4.8 8.55s5.38 4.25 8.65 3.91c3.08-.34 5.71-2.51 7.37-5.13a31 31 0 0 0 3.27-8.66 27.74 27.74 0 0 0 .36-11.28c-1.09-7.21-4.16-14.58-6.39-21.28a21.7 21.7 0 0 1-1.55-7 4.45 4.45 0 0 1 .08-.81v-.21a16.36 16.36 0 0 1 2.89-1c.56-.15 1.12-.27 1.7-.37q2.91 15.87 5.91 31.8c0 .25.09.5.14.75.28 1.52.57 3 .88 4.56s.6 2.75.94 4.11c.12.46.24.92.37 1.37.34 1.25.73 2.49 1.17 3.71 2.66 7.44 7.3 14.86 5.59 22.51zM952.57 659.34a9.43 9.43 0 0 0 .88 4.53c1.67 3.06 5.68 3.75 9.16 4a271.08 271.08 0 0 0 60.85-1.86 6.88 6.88 0 0 0 3.09-1c2.87-2 1.1-6.9-2-8.47s-6.84-1.19-10.27-1.87-6.57-2.42-9.61-4.17q-10.44-6-20.58-12.5c-4-2.59-8.77-5.34-13.3-3.81-12.31 4.23-18.3 11.91-18.22 25.15z",
    fill: "#ff6584"
  }), React.createElement("path", {
    d: "M803 506.73c0 .2-.06.38-.1.57s-.11.62-.17.93c-.56 2.87-1.25 5.74-2 8.58-2.18 7.86-5.09 15.59-8 23.21q-11.62 30.65-23.27 61.3c-2 5.15-3.91 10.3-6.13 15.34l-2.33 5.09c-2.73 6.13-5.35 12.46-6.22 19-.57 4.32-1.15 8.74-.28 13s3.47 8.45 7.53 10c2 .77 4.83 1.81 4.28 3.87-.29 1.14-1.58 1.69-2.73 1.88a10.53 10.53 0 0 1-8.59-2.47c-2.17-1.93-3.84-4.92-6.72-5.25-2-.21-3.84 1-5.67 1.82-7.47 3.41-16.17 1-24-1.4.62-3.17 3.81-5.27 7-5.9s6.45-.19 9.68-.27a5.12 5.12 0 0 0 2.94-.76 5.35 5.35 0 0 0 1.58-2.71 113.93 113.93 0 0 0 4.63-18.93c1-6.72 1.47-13.54 3-20.17 1.16-5.18 2.94-10.2 4.47-15.28 3.14-10.41 5.22-21.11 7.29-31.78a114.1 114.1 0 0 0 2.05-13.49c.26-3.76.13-7.54.5-11.29a87.93 87.93 0 0 1 3-14.39q2.07-7.69 4.15-15.39c2.05-7.59 4.26-15.47 9.46-21.37a20.1 20.1 0 0 1 14.43-6.89 14.29 14.29 0 0 1 3.07.33l.5.13a12.17 12.17 0 0 1 3.13 1.29c1.61-1 2.42-.66 3.49.91a10.13 10.13 0 0 1 1.27 5.47 75.92 75.92 0 0 1-1.24 15.02z",
    fill: "#fbbebe"
  }), React.createElement("path", {
    d: "M804.77 512.74l-.07.07-.37.36-3.64 3.64-1.79-7.5-6.12-25.7a14.29 14.29 0 0 1 3.07.33 5 5 0 0 1 .21-.87l.29 1 2.08 7 3.93 13.4.64 2.21z",
    fill: "#ff6584"
  }), React.createElement("rect", {
    x: 769.88,
    y: 412.62,
    width: 57.99,
    height: 36.24,
    rx: 12,
    fill: "#3f3d56"
  }), React.createElement("circle", {
    cx: 848.26,
    cy: 413.52,
    r: 18.57,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M847.8 394.95h-.68a18.57 18.57 0 0 1 0 37.11h.68a18.58 18.58 0 1 0 0-37.15zM759.46 394.95h.68a18.57 18.57 0 0 0 0 37.11h-.68a18.58 18.58 0 0 1 0-37.15zM822.43 445.24h-47.11a5.46 5.46 0 0 1-5.44-5.44v3.62a5.46 5.46 0 0 0 5.44 5.44h47.11a5.46 5.46 0 0 0 5.44-5.44v-3.62a5.46 5.46 0 0 1-5.44 5.44z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M874.37 732.82l3-136.39a8.07 8.07 0 0 1 7.3-7.85 1029.74 1029.74 0 0 1 194.08 0 8.07 8.07 0 0 1 7.34 8v136.37a8.06 8.06 0 0 1-7.67 8c-66.86 3.14-132.38 3.29-196.37 0a8.06 8.06 0 0 1-7.68-8.13z",
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 896.5,
    y: 613.48,
    width: 74,
    height: 17,
    rx: 2.25,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 897,
    y: 642.98,
    width: 169,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("rect", {
    x: 897,
    y: 663.98,
    width: 169,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("rect", {
    x: 897,
    y: 684.98,
    width: 112,
    height: 8,
    rx: 2.25,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M960.94 579.82s4.69 13.49 9 9.9l-3.41-17.64z",
    fill: "#fbbebe"
  }));
};

UndrawSocialShare.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawSocialShare;